import { render, staticRenderFns } from "./workSubmit.vue?vue&type=template&id=6c6a0210&scoped=true&"
import script from "./workSubmit.vue?vue&type=script&lang=js&"
export * from "./workSubmit.vue?vue&type=script&lang=js&"
import style0 from "./workSubmit.vue?vue&type=style&index=0&id=6c6a0210&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6a0210",
  null
  
)

export default component.exports